<div class="card">
    <div class="card-body">
        <div class="d-flex align-items-center mb-3 flex-wrap gap-2">
            <button type="button" class="bill-service__back-icon me-2" (click)="goBack()" aria-label="Regresar">
                <i class="ti ti-arrow-left"></i>
            </button>
            <h4 class="mb-0">Factura de servicio - Folio {{ folio }}</h4>
            <span *ngIf="isRefactura" class="invoice-view__tag invoice-view__tag--warning">Refacturada</span>
            <span *ngIf="isCancelled" class="invoice-view__cancelled-badge">Factura Cancelada</span>
        </div>

        <!-- Historial de refacturación: la cadena completa de CFDI sustituidos -->
        <div class="invoice-view__history" *ngIf="hasHistory">
            <button type="button" class="invoice-view__history-head" (click)="toggleHistory()"
                    [attr.aria-expanded]="historyOpen">
                <span class="invoice-view__history-title">
                    Historial de refacturación
                    <span class="invoice-view__history-count">{{ refacturaChain.length }}</span>
                </span>
                <i class="ti" [class.ti-chevron-down]="!historyOpen" [class.ti-chevron-up]="historyOpen"></i>
            </button>

            <div class="invoice-view__history-body" *ngIf="historyOpen">
                <div *ngFor="let entry of refacturaChain"
                     class="invoice-view__history-row"
                     [class.is-current]="entry.is_current"
                     [class.is-link]="!entry.is_current"
                     (click)="openChainEntry(entry)">
                    <span class="invoice-view__history-folio">Factura de servicio {{ entry.folio }}</span>
                    <span class="invoice-view__tag"
                          [ngClass]="'invoice-view__tag--' + badgeFor(entry).kind">{{ badgeFor(entry).label }}</span>
                    <span class="invoice-view__history-current" *ngIf="entry.is_current">Estás viendo esta</span>
                    <span class="invoice-view__history-date">{{ dateFor(entry) | date:'dd/MM/yyyy' }}</span>
                </div>
            </div>
        </div>

        <div class="d-flex align-items-center mb-3 flex-wrap gap-2">
            <div class="d-flex align-items-center gap-2 flex-wrap">
                <button type="button" class="btn invoice-view__btn-action" (click)="onDownloadPdf()">
                    <i class="ti ti-download"></i> <span>Descargar PDF</span>
                </button>
                <button type="button" class="btn invoice-view__btn-action" (click)="onDownloadXml()">
                    <i class="ti ti-download"></i> <span>Descargar XML</span>
                </button>
                <button type="button" class="btn invoice-view__btn-action" (click)="onCancelInvoice()" [disabled]="invoice?.status === 'Cancelada'">
                    <i class="ti ti-x"></i> <span>Cancelar factura</span>
                </button>
                <button type="button" class="btn invoice-view__btn-action" (click)="onRefacturar()">
                    <i class="ti ti-file-pencil"></i> <span>Refacturar</span>
                </button>
            </div>
        </div>

        <div *ngIf="loading" class="text-muted">Cargando…</div>

        <div *ngIf="!loading && invoice" class="invoice-view__body">
            <div class="row g-3">
                <div class="col-md-4">
                    <div class="bill-service__field-label">Folio</div>
                    <div class="bill-service__field-value">{{ invoice.folio }}</div>
                </div>
                <div class="col-md-4">
                    <div class="bill-service__field-label">Fecha de emisión</div>
                    <div class="bill-service__field-value">{{ invoice.issued_at }}</div>
                </div>
                <div class="col-md-4">
                    <div class="bill-service__field-label">Estatus</div>
                    <div class="bill-service__field-value">{{ invoice.status }}</div>
                </div>
                <div class="col-md-4">
                    <div class="bill-service__field-label">Total</div>
                    <div class="bill-service__field-value">${{ invoice.total | number:'1.2-2' }}</div>
                </div>
                <div class="col-md-4" *ngIf="invoice.client?.name">
                    <div class="bill-service__field-label">Cliente</div>
                    <div class="bill-service__field-value">{{ invoice.client.name }}</div>
                </div>
                <div class="col-md-4" *ngIf="invoice.client?.rfc">
                    <div class="bill-service__field-label">RFC</div>
                    <div class="bill-service__field-value">{{ invoice.client.rfc }}</div>
                </div>
            </div>
        </div>

        <div *ngIf="!loading && !invoice" class="text-muted">No se encontró la factura.</div>

        <div *ngIf="!loading && invoice?.pdf_path" class="invoice-view__pdf mt-4">
            <h5 class="mb-2">Vista previa del PDF</h5>
            <div *ngIf="pdfLoading" class="text-muted">Cargando PDF…</div>
            <div *ngIf="pdfError" class="text-danger">No se pudo cargar la vista previa del PDF.</div>
            <iframe
                *ngIf="pdfUrl && !pdfError"
                [src]="pdfUrl"
                title="Vista previa CFDI"
                class="invoice-view__pdf-frame"
                width="100%"
                height="800"
                style="border: 1px solid #dee2e6; border-radius: 4px;"
            ></iframe>
        </div>
    </div>
</div>
